(function () {
  function formatErrors(errors) {
    if (!errors) return '';
    if (typeof errors === 'string') return errors;
    if (Array.isArray(errors)) return errors.join(' ');
    return Object.values(errors).flat().join(' ');
  }

  function isDuplicateError(text) {
    const value = text.toLowerCase();
    return (
      value.includes('already') ||
      value.includes('taken') ||
      value.includes('exists') ||
      value.includes('subscribed')
    );
  }

  function initSubscribe(root) {
    const formWrap = root.querySelector('.site-footer__subscribe-form-wrap');
    const form = root.querySelector('[data-footer-subscribe-form]');
    const feedback = root.querySelector('[data-footer-subscribe-feedback]');
    const emailInput = form && form.querySelector('input[type="email"]');
    const submitBtn = form && form.querySelector('[type="submit"]');

    if (!formWrap || !form || !feedback || !emailInput || !submitBtn) return;

    const messages = {
      success: root.dataset.successMessage || 'Thanks for subscribing!',
      error: root.dataset.errorMessage || 'Something went wrong. Please try again later.',
      invalid: root.dataset.invalidMessage || 'Please enter a valid email address.'
    };

    function setLoading(isLoading) {
      submitBtn.disabled = isLoading;
      submitBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function showMessage(type, text) {
      feedback.hidden = false;
      feedback.className = 'site-footer__subscribe-message site-footer__subscribe-message--' + type;
      feedback.textContent = text;
      feedback.setAttribute('role', type === 'error' ? 'alert' : 'status');
    }

    function clearMessage() {
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.className = 'site-footer__subscribe-message';
    }

    function showSuccess(text) {
      form.hidden = true;
      showMessage('success', text);
    }

    async function parseResponse(response) {
      if (response.redirected && response.url.includes('/challenge')) {
        return {
          status: false,
          errors: 'Verification required. Please wait a moment and try again.'
        };
      }

      const contentType = response.headers.get('content-type') || '';

      if (contentType.includes('application/json')) {
        return response.json();
      }

      const text = await response.text();
      if (text.includes('h-captcha') || text.includes('/challenge')) {
        return {
          status: false,
          errors: 'Verification required. Please wait a moment and try again.'
        };
      }

      if (response.ok) {
        return { status: true };
      }

      return {
        status: false,
        errors: text
      };
    }

    formWrap.addEventListener('submit', async function (event) {
      event.preventDefault();

      const email = emailInput.value.trim();
      if (!email || !emailInput.checkValidity()) {
        form.hidden = false;
        showMessage('error', messages.invalid);
        emailInput.focus();
        return;
      }

      setLoading(true);
      clearMessage();

      const formData = new FormData(formWrap);
      formData.set('contact[email]', email);
      formData.set('contact[tags]', 'newsletter');
      formData.set('contact[accepts_marketing]', 'true');

      if (!formData.get('form_type')) {
        formData.set('form_type', 'customer');
      }

      try {
        const response = await fetch('/contact', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        const data = await parseResponse(response);
        const errorText = formatErrors(data.errors || data.description || data.message);

        if (data.status || response.ok) {
          showSuccess(messages.success);
          return;
        }

        if (isDuplicateError(errorText)) {
          showSuccess(messages.success);
          return;
        }

        form.hidden = false;
        showMessage('error', errorText || messages.error);
      } catch (error) {
        form.hidden = false;
        showMessage('error', messages.error);
      } finally {
        setLoading(false);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-footer-subscribe]').forEach(initSubscribe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
